import { NavLink } from 'reactstrap'
import PropTypes from 'prop-types'
import { CustomerRefundPaymentMethodBadge, CustomerRefundPaymentStatusBadge } from 'domains/customer-refund-payment/atoms'

const propTypes = {
  refundPayment         : PropTypes.object,
  onClickDetail         : PropTypes.func,
  onClickChangeIsActive : PropTypes.func
}

const RefundPaymentTableRow = ({
  refundPayment
}) => {

  const {
    id,
    refund_number,
    transaction_no,
    customer_bank,
    transfer_method,
    status
  } = refundPayment
  const buttonClassName = 'align-self-center my-1 mx-auto'

  return (
    <tr >
      <td>{ refund_number }</td>
      <td>{ transaction_no }</td>
      <td>{ customer_bank?.holder_name }</td>
      <td><CustomerRefundPaymentMethodBadge method={ transfer_method } /></td>
      <td><CustomerRefundPaymentStatusBadge status={ status } /></td>
      <td>{ customer_bank?.name }</td>
      <td>{ customer_bank?.account_number }</td>
      <td>
        <NavLink
          className={ `btn btn-primary text-white ${buttonClassName}` }
          href={ `/app/orders/refunds/payments/${id}` }
        >
          { 'Detail' }
        </NavLink>
      </td>
    </tr>
  )
}

RefundPaymentTableRow.propTypes = propTypes
export default RefundPaymentTableRow